(function () {
  const normalizeIntent = (value) => {
    if (!value) return null;
    const intent = value.toLowerCase().trim();
    if (['rip', 'live', 'rip-live', 'riplive'].includes(intent)) return 'rip-live';
    if (['sealed', 'ship', 'ship-sealed', 'shipsealed'].includes(intent)) return 'sealed';
    return null;
  };

  const updateStatus = (field, value) => {
    const title = field.querySelector('[data-toak-status-title]');
    const copy = field.querySelector('[data-toak-status-copy]');
    if (!title || !copy) return;

    if (value === 'rip-live') {
      title.textContent = 'Ripped live';
      copy.textContent = 'We will open this item during our next livestream.';
    } else {
      title.textContent = 'Ships sealed';
      copy.textContent = 'This product will be shipped to you factory sealed.';
    }
  };

  const initialize = (field) => {
    if (field.dataset.toakInitialized === 'true') return;
    field.dataset.toakInitialized = 'true';

    const params = new URLSearchParams(window.location.search);
    const requestedIntent = normalizeIntent(params.get('fulfillment'));
    const desiredInput = requestedIntent
      ? field.querySelector(`[data-fulfillment-value="${requestedIntent}"]`)
      : field.querySelector('[data-fulfillment-value="sealed"]');

    if (desiredInput) desiredInput.checked = true;
    updateStatus(field, desiredInput?.dataset.fulfillmentValue || 'sealed');

    field.addEventListener('change', (event) => {
      const input = event.target.closest('[data-fulfillment-value]');
      if (!input) return;
      updateStatus(field, input.dataset.fulfillmentValue);
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-toak-fulfillment]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
